/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

import { formatErrorResponse } from 'responseFormatterFunctions';
import { I18NError } from 'Utils';
import { fetchPost } from 'FetchAPIs';

const asEngineURL = '/api/asengine';
const messages = defineMessages({
  errorRunningFunction: 'Error executing the function. {message}',
});

/** execute a function on the analytics engine with params */
export function createSampleDeviceTypes(functionId, params) {
  return fetchPost(`${asEngineURL}/catalog_function/${functionId}`, params).catch(error => {
    throw new I18NError(messages.errorRunningFunction, {
      message: formatErrorResponse(error),
    });
  });
}
